import { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import { clone } from '../../../core/utils';
import { formatDate, formatGender, formatStatus } from '../../../components/renderers';
import { create, isValid } from '../../../components/form';
import { extendedstyles } from '../../appstyles';
import { Box } from '@mui/material';

const s:any ={
  container: {
    display: 'flex',
    // flexWrap: 'wrap',
  },
  formcontainer: {
    overflow: 'scroll',
  },
  hide: {
    display: 'none'
  },
  spinner: {
    backgroundImage: 'url(assets/img/loading.gif)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    margin: 'auto',
    width: 40,
    height: 40,
  },
};

class AccountPanel extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      source: {},
      preview: false,
      valid: false,
      count:0
    };
  }

  componentDidMount(){
    this.props.setValid(this.state.valid);
  }

  formconfig = () => {
    const config = {
      service: {
        name: 'account',
        title: 'Account Information',
        eform: [
          //{id:'acn',label:'Account No',type:'fa',req:1,ops:{filters:{ati:2}},cp:{t:'bcs',s:'account'}},
          {id:'nam',label:'Customer',type:'tf',req:0,ops:{},off:['add']},
          {id:'acn',label:'Account No',type:'tf',req:1,ops:{}},
          {id:'mbn',label:'Mobile No',type:'tf',req:1,ops:{}},
          {id:'cli',label:'Network',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'client'}},
        ],
      },
      create: true,
      actions: { add: 'Add' },
      panels: { add: 'simple' },
    };
    return config;
  }

  setValid = (data:any)  => {
    const config = this.formconfig();
    const valid = isValid(config,data);
    //console.log('valid:',valid);
    this.props.setValid(valid);
  }

  onChange = (name:any) => (value:any) => {
    //console.log('wizform.onChange:',name, value,this.props.data);
    const {data} = this.props;
    const newdata = {...data.data,[name]:value};
    this.setValid(newdata);
    this.props.setItem('data','data',newdata);
  }

  makeform = () => {
    const config = this.formconfig();
    const { record, classes, extras } = this.props;
    const sconfig = clone(config);
    const sdata = sconfig.service;
    const mode = 'add';
    const formatters = {dob:formatDate, sts:formatStatus};
    const onChange = this.onChange.bind(this);
    const form = create(mode,sdata,record,formatters,onChange,classes,extras);
    return form;
  }

  render() {
    const {loading,data} = this.props;
    const form = this.makeform();
    return (
      <Box>
        <Box sx={{...(loading?s.spinner:s.hide)}}></Box>
        {form}
      </Box>
    );
  }
}

export default AccountPanel;
